import React, { useCallback, useMemo } from 'react';

import { Consolidation } from '@futrli-sdk/consolidations';
import { useIntl } from '@futrli/localisation';
import { VirtualizedCardList } from '@futrli/predict/ui/virtualized-card-list/virtualized-card-list';
import { VirtualizedCardListEmptyState } from '@futrli/predict/ui/virtualized-card-list/virtualized-card-list-empty-state';

import {
  ConsolidationRow,
  ConsolidationRowItem,
  ROW_HEIGHT_DEFAULT
} from './components/consolidation-row/consolidation-row';

interface ConsolidationsListProps {
  consolidations?: Consolidation[];
  isLoading?: boolean;
}

export const ConsolidationsList = ({ consolidations = [], isLoading = false }: ConsolidationsListProps) => {
  const intl = useIntl();

  const data = useMemo<ConsolidationRowItem[]>(() => consolidations.map(consolidation => ({ consolidation })), [
    consolidations
  ]);

  const renderRow = useCallback((item: ConsolidationRowItem) => {
    return <ConsolidationRow item={item} />;
  }, []);

  const rowHeight = useCallback(() => ROW_HEIGHT_DEFAULT, []);

  return (
    <VirtualizedCardList<ConsolidationRowItem>
      data={data}
      renderRow={renderRow}
      rowHeight={rowHeight}
      isLoading={isLoading}
      emptyState={
        <VirtualizedCardListEmptyState
          title={intl.formatMessage({
            id: 'predict.consolidation.no_consolidations',
            defaultMessage: 'No consolidations to show'
          })}
        />
      }
    />
  );
};
